<script>
import { AxiosAPI } from '@/axios';
import { useMainStore } from '../../../stores/index';
import Breadcrumb from '../../documents/patchName.vue';
import profileImg from './components/profile_img.vue';
export default {
  name: 'files_users_screen',
  components: {
    Breadcrumb,
    profileImg
  },
  setup () {
    const StoreAll = useMainStore();
    return {
      Store: StoreAll
    };
  },
  data () {
    return {
      data: this.$route.params.id,
      user: [],
      progress: 0,
      componenteHeight: '93vh',
      see_documents: false,
      send_documents: false,
      attachs: [],
      attachs_details: [],
      files: []
    };
  },
  mounted () {
    this.getUser();
  },

  methods: {

    checkComponentHeight () {
      const componente = document.getElementById('Servidores');
      const alturaViewport = window.innerHeight;

      if (componente.clientHeight < 0.93 * alturaViewport) {
        this.componenteHeight = '92.5vh';
      } else {
        this.componenteHeight = componente.clientHeight < 0.93 * alturaViewport + 'vh';
      }
    },

    getUser () {
      const id = parseInt(this.data);
      const userNow = [];
      this.Store.users.forEach(users => {
        if (users.id === id) {
          userNow.push(users);
        }
      });
      this.user = userNow;
      this.getArchive();
    },

    getArchive () {
      AxiosAPI.get('/api/archives',
        {
          headers: {
            Authorization: 'Bearer ' + this.Store.accessToken
          }
        })
        .then((resp) => {
          console.log(resp);
          this.files = resp.data.archives.files;
        });
    },

    inputFiles (event) {
      const files = event.target.files;
      this.attachs.push(...files);
    },

    uploadFiles () {
      const interval = setInterval(() => {
        if (this.progress < 90) {
          this.progress += 10;
        }
      }, 1000);
      this.$refs.hiddenButton.click();
      const formData = new FormData();

      for (let i = 0; i < this.attachs.length; i++) {
        formData.append('documents[]', this.attachs[i]);
      }
      formData.append('folder_name', 'files');
      formData.append('user_id', this.data);

      AxiosAPI.post('/api/archives', formData,
        {
          headers: {
            Authorization: 'Bearer ' + this.Store.accessToken
          }
        })
        .then((resp) => {
          if (resp.status === 200) {
            this.send_documents = false;
            this.attachs = [];
            this.getArchive();
            this.progress = 100;
            clearInterval(interval);
            setTimeout(() => {
              this.$refs.hiddenButtonClose.click();
              this.progress = 0;
            }, 1500);
          } else {
            this.$refs.hiddenButtonClose.click();
          }
        });
    },

    downloadFile (value) {
      const interval = setInterval(() => {
        if (this.progress < 90) {
          this.progress += 10;
        }
      }, 1000);
      this.$refs.hiddenButton.click();

      AxiosAPI.post('/api/archives/' + value + '/download', {},
        {
          headers: {
            Authorization: 'Bearer ' + this.Store.accessToken
          }
        })
        .then((resp) => {
          if (resp.status === 200) {
            console.log(resp);
            this.getArchive();
            this.progress = 100;
            clearInterval(interval);
            setTimeout(() => {
              this.$refs.hiddenButtonClose.click();
              this.progress = 0;
            }, 1500);
          } else {
            this.$refs.hiddenButtonClose.click();
          }
        });
    }

  }
};
</script>

<template>
<div class="py-4 container-fluid" id="Servidores" :style="{ minHeight: componenteHeight }">
    <Breadcrumb />
    <div class='d-flex justify-content-center container'>
          <div class="row">
            <profileImg :img="user[0]?.path_image ?? ''" />
            <div class="col-sm d-flex flex-column justify-content-center align-items-center">
                <h3 class="text-center">{{ user[0]?.name ?? '' }}</h3>
                <p class="text-center">{{ user[0]?.email ?? '' }}</p>
            </div>
        </div>
    </div>
    <div v-if="!see_documents && !send_documents" class='d-flex justify-content-center container'>
      <div class="row">
        <div class="col-sm d-flex flex-column justify-content-center align-items-center">
         <button class="btn btn-dark m-2 w-100" @click="see_documents = true">
            Visualizar Documentos
        </button>
        </div>
        <div class="col-sm d-flex flex-column justify-content-center align-items-center">
          <button class="btn btn-dark m-2 w-100"  @click="send_documents = true">
            Enviar Documentos
          </button>
        </div>
      </div>
    </div>
    <div v-if="send_documents" class='d-flex justify-content-center container'>
      <div class="row">
        <div class="col-sm d-flex flex-column justify-content-center align-items-center">
         <labe>Selecione os documentos que deseja enviar</labe>
          <input type="file" class="form-control text-center" multiple @change="inputFiles($event)" />
        </div>
        <div v-if="attachs.length >= 1" class="mt-3 mb-3">
          <div class="d-flex justify-content-center">
           <span class="text-center">Documentos selecionados</span>
          </div>
          <div v-for="documents in attachs" :key="documents" class="d-flex justify-content-center align-items-center mt-2">
            <div class="d-flex" style="align-items: center;">
              <img src="../../../assets/img/pdf.png" class="img-thumbnail" style="width: 30px; height: 30px; margin-right: 10px;" />
              <span class="text-center aling-items-center" style="align-items: center;">{{ documents.name }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <button class="btn btn-secondary m-2 w-100" @click="send_documents = false; attachs = []">
            voltar
          </button>
          <button v-if="attachs.length >= 1" class="btn btn-success m-2 w-100" @click="uploadFiles">
            Enviar
          </button>
          </div>
      </div>
    </div>
    <div v-if="see_documents">
        <div v-if="files.length >= 1" class="mt-3 mb-4">
          <div v-for="file in files" :key="file.id" class="d-flex justify-content-center mt-2">
            <div style="cursor: pointer;" @click="downloadFile(file.id)">
             <img src="../../../assets/img/pdf.png" class="img-thumbnail" style="width: 30px; height: 30px; margin-right: 10px;" />
              <span class="text-center">{{ file.original_filename }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <button class="btn btn-secondary m-2" @click="see_documents = false">
            voltar
          </button>
          </div>
    </div>
    <button type="button" ref="hiddenButton" class="btn btn-primary d-none" data-toggle="modal" data-target="#exampleModalCenter"></button>
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="background-color:  rgba(0,0,0,0) !important; border: 0px">
          <button type="button" ref="hiddenButtonClose" class="close d-none" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          <div class="modal-body">
            <span class="font-docs text-white d-flex justify-content-center">Concluindo envio, Por favor, aguarde...</span>
            <div class="progress" style="height: 30px;">
              <div class="progress-bar" role="progressbar" :style="'width:' + this.progress + '%'" style="height: 30px;
              animation: progress-bar-stripes 1s linear infinite !important;
              background-image: linear-gradient(62deg, hsla(0, 0%, 100%, .15) 25%, transparent 0, transparent 50%, hsla(0, 0%, 100%, .15) 0, hsla(0, 0%, 100%, .15) 75%, transparent 0, transparent) !important;
              background-size: 0.5rem 1rem;
              transition: width .6s ease;
              background-color: #F1860B;" :aria-valuenow="this.progress" aria-valuemin="0" aria-valuemax="100">{{this.progress}}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>
